module.exports = __webpack_public_path__ + "static/media/wasps.2787b1bb.jpg";